import { AxiosRequestConfig, AxiosResponse } from 'axios';

export async function withRetry(
  handler: <T = any, R = AxiosResponse<T, any>, D = any>(
    url: string,
    config?: AxiosRequestConfig<D> | undefined
  ) => Promise<R>,
  url: string,
  config: AxiosRequestConfig,
  retryDelay: number = 3000,
  retryStatus: number = 202,
  retriesLimit: number = Infinity
) {
  let currentRetry = 0;

  while (currentRetry < retriesLimit) {
    currentRetry++;

    const response = await handler(url, config);

    if (response.status !== retryStatus) {
      return response;
    }

    /*
      this code aims to wait retryDelay timeout
      before go to the next iteration?
      it is just a postponed run  */
    await new Promise(resolve => {
      setTimeout(() => {
        resolve('resolved');
      }, retryDelay);
    });
  }

  return Promise.reject('');
}
